'use strict';

var SubmitForCalibrationAnalysisModalDirective = function SubmitForCalibrationAnalysisModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/submit-for-calibration-analysis-modal.html'),
    link: function link(scope, element) {
      element.find('.gdpr-popover').popover();
    }
  };
};
module.exports = SubmitForCalibrationAnalysisModalDirective;